<template>
  <ux-form
    ref="form"
    :data="formData"
    width="600px"
    :colon="true"
    :rules="rules"
    label-width="70px"
    data-automation="addLicense"
  >
    <ux-form-item :label="$t('HT.addLicense.userName')" prop="title">
      <ux-input
        v-model="formData.title"
        :minlength="4"
        :maxlength="64"
        :placeholder="$t('HT.addLicense.userName.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.phone')" prop="phone">
      <ux-input
        v-model="formData.phone"
        :maxlength="11"
        :placeholder="$t('HT.addLicense.phone.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.sales')" prop="sales">
      <ux-input
        v-model="formData.sales"
        :maxlength="32"
        :placeholder="$t('HT.addLicense.sales.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.engineer')" prop="engineer">
      <ux-input
        v-model="formData.engineer"
        :maxlength="32"
        :placeholder="$t('HT.addLicense.engineer.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.maxConn')" prop="max_conn">
      <ux-input
        v-model="formData.max_conn"
        :maxlength="6"
        :placeholder="$t('HT.addLicense.maxConn.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.maxHosts')" prop="max_hosts">
      <ux-input
        v-model="formData.max_hosts"
        :maxlength="3"
        :placeholder="$t('HT.addLicense.maxHosts.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.expireDate')" prop="expire_date">
      <ux-radio v-model="formData.expire_date" :options="$opt.expire_date"></ux-radio>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.date')" v-if="formData.expire_date === 0">
      <ux-date v-model="formData.date" top></ux-date>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          title: '', // 客户名
          phone: '', // 联系方式
          sales: null, // 销售
          engineer: null, // 技术支持
          max_conn: '', // 最大连接数
          max_hosts: '', // 最大网卡数
          expire_date: '', // 有效期
          tags: '', // json标签格式
          date: ''
        };
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      rules: this.$rul.addLicense()
    };
  }
};
</script>
